module.exports = __webpack_public_path__ + "static/media/IMG_0641_Reduced.38c31300.jpg";